import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Products() {
  const { categorySlug } = useParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setLoading(true);
    (async () => {
      const [c, p] = await Promise.all([
        api.get("/categories"),
        api.get(`/products${categorySlug ? `?category=${categorySlug}` : ""}`),
      ]);
      setCategories(c.data);
      setProducts(p.data);
      setLoading(false);
    })().catch(() => setLoading(false));
  }, [categorySlug]);

  const filtered = products.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const currentCat = categories.find((c) => c.slug === categorySlug);

  return (
    <div data-testid="products-page" className="bg-[#F4F7F9] min-h-screen">
      <div className="bg-white border-b border-slate-100">
        <div className="container-max px-4 md:px-8 py-12">
          <div className="overline mb-2">Mağaza</div>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter">
            {currentCat ? currentCat.name : "Tüm Ürünlerimiz"}
          </h1>
          {currentCat && <p className="mt-3 text-slate-600 max-w-2xl">{currentCat.description}</p>}
        </div>
      </div>

      <div className="container-max px-4 md:px-8 py-10 grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3">
          <div className="bg-white rounded-2xl p-5 border border-slate-100 sticky top-24">
            <div className="overline mb-3">Kategoriler</div>
            <div className="space-y-1">
              <Link
                to="/urunler"
                className={`block px-3 py-2 rounded-lg text-sm font-semibold ${!categorySlug ? "bg-[#0077B6] text-white" : "hover:bg-slate-50"}`}
                data-testid="cat-all"
              >
                Tüm Ürünler
              </Link>
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/urunler/${c.slug}`}
                  data-testid={`cat-${c.slug}`}
                  className={`block px-3 py-2 rounded-lg text-sm font-semibold ${categorySlug === c.slug ? "bg-[#0077B6] text-white" : "hover:bg-slate-50"}`}
                >
                  {c.name}
                </Link>
              ))}
            </div>

            <div className="mt-6">
              <div className="overline mb-3">Arama</div>
              <input
                data-testid="product-search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Ürün ara..."
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-[#0077B6]"
              />
            </div>
          </div>
        </aside>

        <main className="lg:col-span-9">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-white rounded-xl border border-slate-100 aspect-[3/4] animate-pulse" />
              ))}
            </div>
          ) : filtered.length === 0 ? (
            <div className="bg-white rounded-2xl p-12 text-center border border-slate-100">
              <p className="text-slate-600">Bu kategoride henüz ürün bulunmuyor.</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
